import {InjectionToken} from '@angular/core';
import {AppModalType} from '../../types/modal/app-modal.type';

export const APP_MODAL_REF: InjectionToken<AppModalType> = new InjectionToken<AppModalType>('APP_MODAL_REF');